import { api } from '../../';
import { CampaignImageDto } from './types';

// TODO: Obtain campaignId to selected campaign
const CAMPAIGN_ID = 1;

export const raffleImagesApi = api.enhanceEndpoints({ addTagTypes: ['RaffleImages'] }).injectEndpoints({
  endpoints: build => ({
    getRaffleImagesConfig: build.query<CampaignImageDto[], void>({
      query: () => ({
        url: `v1/promotions/admin/campaigns/${CAMPAIGN_ID}/images`,
        method: 'GET',
      }),
    }),
    saveRaffleImagesConfig: build.mutation<CampaignImageDto[], FormData>({
      query: body => ({
        url: `v1/promotions/admin/campaigns/${CAMPAIGN_ID}/images`,
        method: 'PATCH',
        body,
      }),
    }),
  }),
});

export const { useLazyGetRaffleImagesConfigQuery, useSaveRaffleImagesConfigMutation } = raffleImagesApi;
